import { Routes } from '@angular/router';

import { AdministrationComponent } from './components/administration/administration.component';

export const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: 'admin',
				children: [
					{
						path: '',
						component: AdministrationComponent,
					},
				],
			},
		],
	},
];
